import { postAction } from './method'
import {METHOD, request} from "@/utils/request";

// 内容管理
export const saveStudyCenter = data => postAction('/afox/studentCenter/saveStudyCenter', { data }, { 'Content-Type': 'multipart/form-data' }) // 新增/编辑
export const studentCenterPageList = data => postAction('/afox/studentCenter/studentCenterPageList', { data }) // 查询列表
export const studentCenterInfo = data => postAction('/afox/studentCenter/studentCenterInfo', { data }) // 查询详情
export const operateStudyCenter = data => postAction('/afox/studentCenter/operateStudyCenter', { data }) // 发布/撤销/删除
export const queryStudyModulePage = data => postAction('/afox/studyModule/queryStudyModulePage', { data }) // 查询模块分页
export const createStudyModule = data => postAction('/afox/studyModule/create', { data }) // 创建模块
export const updateStudyModule = data => postAction('/afox/studyModule/update', { data }) // 修改模块
export const setDisableModule = data => postAction('/afox/studyModule/setDisable', { data }) // 禁用/启用模块
export const updateDeveloperCategoryState = data => postAction('/afox/developerCategory/updateState', { data }) // 禁用/启用标签
/**
 * 创建标签分类
 */
export const createDeveloperCategory = data => postAction('/afox/developerCategory/create', { data })
/**
 * 更新标签分类
 */
export const updateDeveloperCategory = data => postAction('/afox/developerCategory/modify', { data })

// 平台公告
export const noticeListHomePage = data => postAction('/afox/studentCenter/noticeListHomePage', { data }) // 查询首页公告
export const noticeList = data => postAction('/afox/studentCenter/noticeList', { data }) // 查询公告列表
export const noticeInfo = data => postAction('/afox/studentCenter/noticeInfo', { data }) // 查询公告详情
export const findPromptNoticeList = data => postAction('/afox/studentCenter/findPromptNoticeList', { data }) // 查询弹窗公告

// // 内容配置相关接口
// export const getContentConfigList = data => postAction('/afox/news/content/list', { data }) // 获取内容配置列表
// export const addContentConfig = data => postAction('/afox/news/content/add', { data }) // 新增内容配置
// export const updateContentConfig = data => postAction('/afox/news/content/update', { data }) // 更新内容配置
// export const deleteContentConfig = data => postAction('/afox/news/content/delete', { data }) // 删除内容配置

// 查询系统字典列表
export const listPlateformInfo = data => postAction('/afox/plateformStudyCenter/listPlateformInfo', { data })
// 查询标签字典列表
export const listCategoryInfo = data => postAction('/afox/plateformStudyCenter/listCategoryInfo', { data })

// 查询平台公告列表
export const findCategoryInfoPage = data => postAction('/afox/plateformStudyCenter/findCategoryInfoPage', { data })

// 获取新闻详情
export const getNewsDetail = data => postAction('/afox/studentCenter/noticeInfo', { data })
// 查询渠道字典列表
export const queryAllChannel = data => postAction('/afox/internal/queryAllChannel', { data })
/* 上传图片 */
export const uploadImage = (data) => request('/afox/proxy/uploadImage', METHOD.POST, data)